'use client'

import Image from "next/image";
import {HTMLAttributes, PropsWithChildren} from "react";
import classNames from "classnames";

const Size: any = {
  "sm": "h-8 w-8",
  "md": "h-16 w-16",
  "lg": "h-32 w-32",
  get(s: string): string {
    return Size[s] ? Size[s] : Size['sm']
  }
}
export const Avatar = ({src, size, ...rest}: {
  src: string,
  size?: 'sm' | 'md' | 'lg' | string,
} & PropsWithChildren<HTMLAttributes<HTMLDivElement>>) => {
  return <div
    className={classNames("relative absolute inline-block bg-gray-100 overflow-hidden rounded-3xl ", Size.get(size))} {...rest}>
    <Image src={src ?? '/images/logo.png'} className={Size.get(size)} fill alt={src}/>
  </div>
}